import {
  GOOGLE,
  ADS_CAMPAIGN_TYPE_APP_OPTION,
} from "../../../../utils/constants";
import { useFormContext } from "react-hook-form";
import AdGroupSearchGoogleForm from "./AdGroupSearchGoogleForm";
import AdGroupAppGoogleForm from "./AdGroupAppGoogleForm";
import { useEffect, useState } from "react";
import { waitDelay } from "../../../../utils/date";
import { AdGroupSelectionGate } from "../../../../pages/NewAdsCampaign/components/AdsCampaignSelectionGate";

const AdGroupGoogleForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  //To reset values component when change selectedLevel

  const { watch, sectionSelected } = useFormContext();
  const platformData = watch(`platformsData.${GOOGLE}`) || {};
  const objective = platformData?.objective;

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await waitDelay(1);
      setIsLoading(false);
    })();
  }, [sectionSelected]);

  if (isLoading) return null;

  return (
    <AdGroupSelectionGate>
      {objective === ADS_CAMPAIGN_TYPE_APP_OPTION ? (
        <AdGroupAppGoogleForm />
      ) : (
        <AdGroupSearchGoogleForm />
      )}
    </AdGroupSelectionGate>
  );
};

export default AdGroupGoogleForm;
